import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { localize } from 'react-localize-redux';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import Button from '@material-ui/core/Button';
import * as validator from 'helpers/Validator';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';

import './TenantProfile.css';

let TenantInfoEditable = props => {
  const { handleSubmit, submitPhoto } = props;

  const nameHeader = {
    fontSize: '18px',
    marginBottom: 0,
  };

  const fullName = props.generalDetails ? `${props.generalDetails.full_name}` : '';

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        {!props.disabledProfilePicture && (
          <div className="col-xs-12" style={{ marginBottom: '15px' }}>
            <Field
              name="avatar"
              component={ReduxDropzone}
              fileValidation=".jpeg, .png, .jpg"
              size={120}
              fileChanged={submitPhoto}
              dontShowFiles
              circle
            />
          </div>
        )}
        <div className="col-xs-12" style={{ marginBottom: '10px' }} id="editable">
          <h4 style={nameHeader}> {fullName} </h4>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-6" style={{ marginTop: '10px' }}>
          <label style={{ width: '100%' }} aria-label={props.translate('email').props.children}>
            <Field
              name="email"
              label={props.translate('email')}
              component={TextField}
              hintText={props.translate('email')}
              variant="outlined"
              validate={[validator.required, validator.validEmail]}
            />
          </label>
        </div>
        <div className="col-xs-6" style={{ marginTop: '10px' }}>
          <label
            style={{ width: '100%' }}
            aria-label={props.translate('phoneNumber').props.children}
          >
            <Field
              name="phone_number"
              type="text"
              label={props.translate('phoneNumber')}
              component={ReactPhoneInput}
              validate={[validator.required, validator.validInternationalPhoneNumber]}
            />
          </label>
        </div>
      </div>
      <div classname="row" style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleSubmit}
          style={{ borderWidth: '2px' }}
        >
          {props.translate('update')}
        </Button>
      </div>
    </form>
  );
};

TenantInfoEditable = reduxForm({
  form: 'tenant_profile',
  enableReinitialize: true,
})(TenantInfoEditable);

TenantInfoEditable = connect(state => ({
  initialValues: state.tenantProfile.generalDetails,
  generalDetails: state.tenantProfile.generalDetails,
  disabledProfilePicture: state.dashboard.tenantOverview.disable_residents_profile_picture,
}))(TenantInfoEditable);

export default localize()(TenantInfoEditable);
